import Proxy from './Proxy';

class UserProxy extends Proxy {
  /**
   * The constructor for the CareplanProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/Users', parameters);
  }

  /**
   * Method used to create user profile.
   *
   * @param {id} id.
   *
   * @returns {Promise} The result in a promise.
   */
  create(data) {
    return this.submit('post', `${this.endpoint}/create`, data);
  }

  /**
   * Method used to view user profile.
   *
   * @param {id} id.
   *
   * @returns {Promise} The result in a promise.
   */
  view(id) {
    return this.submit('get', `${this.endpoint}/${id}`);
  }

  /**
   * Method used to view user profile.
   *
   * @param {id} id.
   *
   * @returns {Promise} The result in a promise.
   */
  update(data) {
    return this.submit('post', `${this.endpoint}/${data.id}/update`, data);
  }

    /**
   * Method used to Change user password.
   *
   *
   * @returns {Promise} The result in a promise.
   */
  changePassword(data) {
    return this.submit('post', `${this.endpoint}/updatePassword`, data);
  }


  /**
   * Method used to view user profile.
   *
   * @param {id} id.
   *
   * @returns {Promise} The result in a promise.
   */
  viewAll(data) {
    return this.submit('post', `${this.endpoint}/all`, data);
  }

   /**
   * Method used to request demo.
   *
   * @param {data} data.
   *
   * @returns {Promise} The result in a promise.
   */
  requestDemo(data) {
    return this.submit('post', `${this.endpoint}/requestDemo`, data);
  }
}

export default UserProxy;
